import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import JsonViewer from "../../Custom/JsonViewer";

export default function FullSessionView() {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 300);
    return () => clearTimeout(timer);
  }, [searchText]);

  const v2Merged = useSelector(
    (state: RootState) => state.replay.v2Merged,
    isEqual,
  );

  const loadingSessionEventData = useSelector(
    (state: RootState) => state.replay.loadingSessionEventData,
  );

  const isEmpty = !v2Merged || Object.keys(v2Merged).length === 0;

  if (loadingSessionEventData) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <div className={styles.spinner} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.searchContainer}>
        <input
          type="text"
          className={styles.searchInput}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search..."
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      {isEmpty ? (
        <div className={styles.emptyMessage}>Merged not available</div>
      ) : (
        <div className={styles.jsonContainer}>
          {Object.entries(v2Merged).map(([key, value]) => (
            <div key={key} className={styles.jsonSection}>
              <JsonViewer
                data={value}
                rootName={key}
                searchText={debouncedSearch}
                defaultExpanded={false}
                showFullBranchOnMatch={true}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
